import { Container } from '@/components/Container';
import type { ContentfulEventFragment } from '@/graphql/contentful/api';

import { CampaignSubscriptionForm } from '../CampaignSubscriptionForm/CampaignSubscriptionForm';

export const CampaignSubscriptionSection = (props: ContentfulEventFragment) => {
  return (
    <Container maxWidth='md'>
      <CampaignSubscriptionForm {...props}></CampaignSubscriptionForm>
    </Container>
  );
};
